import { combineReducers } from 'redux';
import data from './getDevicesReducer';
import toggle from './toggleDeviceReducer';
import togglePublic from './togglePublicDeviceReducer';
import update from './updateDeviceReducer';
import current from './currentDevice';
import recipients from './getRecipientsReducer';

const rootReducer = combineReducers({
    data,
    toggle,
    togglePublic,
    update,
    current,
    recipients,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/index.js